module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'userss'
      }
    }
  }, [_vm._v("\n            Users\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View Users")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content user-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.user,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.email) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role",
      "prop": "role"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.role) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer",
      "prop": "customerId"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.customer.name) + "\n            ")])], 1), _vm._v(" "), _c('hr')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23c95796!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/users/View.vue
// module id = 1144
// module chunks = 2